document.addEventListener("click", function (e) {

    const btn = e.target.closest(".tap-shop-btn");

    if (btn) {

        const slide = btn.closest(".look-slide");

        // document.getElementById("popup-look-title").textContent =
        //     slide.dataset.title;

        document.getElementById("popup-look-description").innerHTML =
            slide.dataset.description;

        document.getElementById("popup-look-image").src =
            slide.dataset.image;

        const container = document.getElementById("popup-look-products");

        container.innerHTML =
            slide.querySelector(".look-products-template").innerHTML;

        initShopLook();

        document
            .getElementById("shop-look-modal")
            .classList.add("is-open");

        document.body.classList.add("overflow-hidden");

        return;
    }

    if (
        e.target.closest(".close-look") ||
        e.target.classList.contains("shop-look-overlay")
    ) {

        document
            .getElementById("shop-look-modal")
            .classList.remove("is-open");

        document.body.classList.remove("overflow-hidden");
    }

});

function ordinal(day) {
    if (day > 3 && day < 21) return day + "th";

    switch (day % 10) {
        case 1: return day + "st";
        case 2: return day + "nd";
        case 3: return day + "rd";
        default: return day + "th";
    }
}

function formatDate(offset) {

    const d = new Date();

    d.setDate(d.getDate() + Number(offset));

    return `${ordinal(d.getDate())} ${d.toLocaleString("en-US", {
        month: "short"
    })}`;

}

function initShopLook() {

    document.querySelectorAll(".shop-look-form").forEach(form => {

        if (form.dataset.loaded) return;
        form.dataset.loaded = "1";

        // console.log("bind", form);

        const variants = JSON.parse(
            document.getElementById(
                `variants-${form.dataset.productId}`
            ).textContent
        );

        const variantExtra = JSON.parse(
            document.getElementById(
                `variant-extra-${form.dataset.productId}`
            ).textContent
        );

        const wrapper = form.closest(".t4s-space-item-inner");
        const image = wrapper.querySelector(".shop-look-product-image");
        const imageLink = wrapper.querySelector(".shop-look-image-link");
        const defaultImage = form.dataset.defaultImage;

        const selects = form.querySelectorAll(".variant-option");
        const input = form.querySelector(".variant-id");

        const customizeWrapper = form.querySelector(".customize-properties");

        function toggleCustomizeForm() {

            if (!customizeWrapper || selects.length === 0) return;

            let sizeSelect = null;

            selects.forEach(select => {
                const optionName = select.closest(".variant-group")
                    ?.querySelector("label")
                    ?.textContent
                    ?.trim()
                    ?.toLowerCase();

                if (optionName === "size") {
                    sizeSelect = select;
                }
            });

            if (!sizeSelect) {
                sizeSelect = selects[0];
            }

            const value = sizeSelect.value.trim().toLowerCase();

            customizeWrapper.style.display =
                value === "customize"
                    ? ""
                    : "none";
        }

        function updateVariant() {

            const values = [...selects].map(s => s.value);

            const variant = variants.find(v =>
                values.every((value, i) => v.options[i] === value)
            );

            if (!variant) return;

            if (variant) {

                input.value = variant.id;
                toggleCustomizeForm();

                const preorder = wrapper.querySelector(".shop-look-preorder");
                const meta = variantExtra[variant.id];

                if (preorder && meta) {

                    if (meta.isPreorder) {

                        form.querySelector(".btn-text").textContent = "MADE-TO-ORDER";

                        preorder.style.display = "";

                        preorder.innerHTML =
                            // `Shipping from ${formatDate(meta.dispatchStart)} - ${formatDate(meta.dispatchEnd)}`;
                            `<div class="preorder-shipping">
                                MADE-TO-ORDER
                                <svg viewBox="0 0 15 15" fill="none">
                                    <path d="M6.25501 7.69L6.31801 7.5L6.25501 7.31L5.76801 5.849L8.51901 7.5L5.76801 9.151L6.25501 7.69Z"
                                    fill="currentColor"/>
                                </svg>
                                Shipping from
                                <strong>${formatDate(meta.dispatchStart)} - ${formatDate(meta.dispatchEnd)}</strong>
                            </div>`

                    } else {

                        form.querySelector(".btn-text").textContent = "Add to cart";

                        preorder.style.display = "none";
                        preorder.innerHTML = "";

                    }

                }

                let src =
                    variant?.featured_media?.preview_image?.src ||
                    variant?.featured_image?.src;

                if (!src) {
                    src = form.dataset.defaultImage;
                }

                if (src && src.startsWith("//")) {
                    src = "https:" + src;
                }

                if (image) {
                    image.src = src;
                    image.dataset.src = src;
                }

                if (imageLink) {
                    imageLink.style.backgroundImage = `url("${src}")`;
                }

            }
        }

        selects.forEach(select => {
            select.addEventListener("change", () => {
                updateVariant();
                toggleCustomizeForm();
            });
        });

        updateVariant();
        toggleCustomizeForm();

    });

}

document.addEventListener("DOMContentLoaded", initShopLook);

document.addEventListener("submit", function (e) {

    const form = e.target.closest(".shop-look-form");
    if (!form) return;

    e.preventDefault();

    const btn = form.querySelector(".shop-look-btn");
    const icon = btn.querySelector(".btn-icon");
    const loading = btn.querySelector(".btn-loading");
    const text = btn.querySelector(".btn-text");

    btn.disabled = true;

    icon.style.display = "none";
    loading.style.display = "";
    text.textContent = "Adding...";

    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json"
        },
        body: new URLSearchParams(new FormData(form))
    })
    .then(res => res.json())
    .then(item => {

        showAddedMessage(`${item.product_title} added to cart`);

        document.dispatchEvent(new CustomEvent("cart:refresh"));

    })
    .catch(console.error)
    .finally(() => {

        btn.disabled = false;

        icon.style.display = "";
        loading.style.display = "none";
        text.textContent = "Add to cart";

    });

});

function showAddedMessage(message){

    const toast = document.createElement("div");

    toast.className = "shop-look-toast";

    toast.innerHTML = `
        <svg width="20" height="20" viewBox="0 0 24 24">
            <path fill="#27ae60"
                d="M20.3 5.7a1 1 0 0 1 0 1.4l-10 10a1 1 0 0 1-1.4 0l-5-5a1 1 0 1 1 1.4-1.4L9.6 15l9.3-9.3a1 1 0 0 1 1.4 0z"/>
        </svg>
        <span>${message}</span>
    `;

    document.body.appendChild(toast);

    requestAnimationFrame(()=>{
        toast.classList.add("show");
    });

    setTimeout(()=>{
        toast.classList.remove("show");
        setTimeout(()=>toast.remove(),300);
    },2500);

}

document.querySelectorAll(".shop-look-slider").forEach(slider => {
    const options = JSON.parse(slider.dataset.flickityt4sJs);

    const total = slider.querySelectorAll(".t4s-col-item").length;
    const min = window.innerWidth >= 1024 ? 4 : 3;

    options.autoPlay = total >= min ? 2000 : false;

    slider.dataset.flickityt4sJs = JSON.stringify(options);
});

document.querySelectorAll(".complete-slider").forEach(slider => {
    const options = JSON.parse(slider.dataset.flickityt4sJs);

    const total = slider.querySelectorAll(".pr-complete-loop").length;
    const min = window.innerWidth >= 1024 ? 4 : 3;

    options.autoPlay = total >= min ? 2000 : false;

    slider.dataset.flickityt4sJs = JSON.stringify(options);
});

function getContrastColor(hex) {
    hex = hex.replace("#", "");

    if (hex.length === 3) {
        hex = hex.split("").map(c => c + c).join("");
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    return brightness > 160 ? "#222222" : "#FFFFFF";
}

function updateProductButtonColor() {

    const swatch = document.querySelector(
        ".is-t4s-style__color .t4s-swatch__item.is--selected"
    );

    if (!swatch) return;

    const form = swatch.closest("form");

    if (!form) return;

    const button = form.querySelector("[data-atc-form]");

    if (!button) return;

    const value = swatch.dataset.value?.trim();

    if (!value) return;

    const cls =
        "bg_color_" +
        value
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "");

    const temp = document.createElement("div");
    temp.className = cls;
    temp.style.display = "none";

    document.body.appendChild(temp);

    let color = getComputedStyle(temp)
        .getPropertyValue("--t4s-bg-color")
        .trim();

    temp.remove();

    const overrideColors = {
        white: "#F2E8D5",
        ivory: "#F3EFE6",
        cream: "#EEE8DD"
    };

    color =
        overrideColors[value.toLowerCase()] ||
        color ||
        "#000000";

    button.style.backgroundColor = color;
    button.style.borderColor = color;

    const textColor = getContrastColor(color);

    button.style.color = textColor;

    button.querySelectorAll("span").forEach(el => {
        el.style.color = textColor;
    });

    button.querySelectorAll("svg").forEach(el => {
        el.style.color = textColor;
        el.style.fill = textColor;
    });
}

function toggleCustomizeFields() {

    const wrapper =
        document.getElementById("customize-properties");

    if (!wrapper) return;

    const selected = document.querySelector(
        ".is-t4s-name__size .t4s-swatch__item.is--selected"
    );

    if (!selected) return;

    wrapper.style.display =
        selected.dataset.value
            ?.trim()
            .toLowerCase() === "customize"
            ? ""
            : "none";
}

document.addEventListener("click", function (e) {

    if (e.target.closest("[data-swatch-item]")) {

        setTimeout(() => {

            updateProductButtonColor();

            toggleCustomizeFields();

        }, 50);

    }

    document.querySelectorAll(".shop-look-form").forEach(form => {

        if (form.contains(e.target)) return;

        const wrapper = form.querySelector(".customize-properties");
        const selects = form.querySelectorAll(".variant-option");

        if (!wrapper || selects.length === 0) return;

        selects[0].selectedIndex = 0;

        selects[0].dispatchEvent(new Event("change", { bubbles: true }));

        wrapper.style.display = "none";

    });


});

document.addEventListener("DOMContentLoaded", () => {

    updateProductButtonColor();

    toggleCustomizeFields();

});

window.addEventListener("load", () => {

    document
        .querySelectorAll(".complete-slider")
        .forEach(slider => {

            const flkty = Flickity.data(slider);

            if (flkty) {

                flkty.resize();

            }

        });

});

document.querySelectorAll(".pr-complete-loop").forEach((element) => {
  element.addEventListener("click", (event) => {
    const title = event?.currentTarget?.dataset?.title;
    window.gtag('event', 'complete_the_look', {
      title: title,
      page_location: window.location.href
    });
  });
});

document.querySelectorAll(".look-slide").forEach((element) => {
  element.addEventListener("click", (event) => {
    const title = event?.currentTarget?.dataset?.title;
    const image =event?.currentTarget?.dataset?.image;
    window.gtag('event', 'shop_the_look', {
    title: title,
    image: image,
    page_location: window.location.href
  });
  });
});

(function () {

    const oldScrollIntoView = Element.prototype.scrollIntoView;

    Element.prototype.scrollIntoView = function (options) {

        if (
            this.closest("[data-main-media]") &&
            this.hasAttribute("data-main-slide")
        ) {

            console.log("Prevent gallery scroll");

            return;
        }

        return oldScrollIntoView.call(this, options);
    };

})();

document.addEventListener("change", function (e) {
  if (e.target.name !== "id") return;

  const option = e.target.selectedOptions[0];
  if (!option) return;

  const mediaId = option.dataset.mdid;
  if (!mediaId) return;

  const gallery = document.querySelector("[data-main-media]");
  if (!gallery) return;

  const slides = [...gallery.querySelectorAll("[data-main-slide]")];

  // remove active
  slides.forEach(slide => slide.classList.remove("is-active"));

  const startIndex = slides.findIndex(
    slide => slide.dataset.mediaId === mediaId
  );

  if (startIndex === -1) return;

  if (slides[startIndex].classList.contains("t4s-product__media-item--variant")) {
    gallery.classList.add("variant-gallery");
  } else {
    gallery.classList.remove("variant-gallery");
  }

  for (let i = startIndex; i < slides.length; i++) {
    if (
      i > startIndex &&
      slides[i].classList.contains("t4s-product__media-item--variant")
    ) {
      break;
    }

    slides[i].classList.add("is-active");
  }
});

(function () {
  function render() {
    const select = document.querySelector('select[name="id"]')
    const box = document.getElementById('preorder-dispatch')

    if (!select || !box) return

    const option = select.selectedOptions[0]

    if (!option) return

    const start = Number(option.dataset.start || 0)
    const end = Number(option.dataset.end || 0)

    const isPreorder =
      option.dataset.inventoryquantity <= 0 &&
      option.dataset.inventorypolicy === 'continue'

    if (!isPreorder || (start === 0 && end === 0)) {
      box.style.display = 'none'
      box.innerHTML = ''
      return
    }

    box.style.display = ''

    box.innerHTML = `
      <div class="preorder-shipping">
        MADE-TO-ORDER
        <svg viewBox="0 0 15 15" fill="none">
          <path
            d="M6.25501 7.69L6.31801 7.5L6.25501 7.31L5.76801 5.849L8.51901 7.5L5.76801 9.151L6.25501 7.69Z"
            fill="currentColor"
          />
        </svg>
        Shipping from
        <strong>${formatDate(start)} - ${formatDate(end)}</strong>
      </div>
    `
  }

  document.addEventListener('DOMContentLoaded', render)

  document.addEventListener('change', function (e) {
    if (e.target.name === 'id') {
      render()
    }
  })

  document.addEventListener('variant:change', render)
})()